import * as React from 'react'
import DatePicker from 'react-datepicker'
import { connect } from 'react-redux'
import { updateParams, fetchVisits } from  './../../redux/actions/visits'
import { Button, TYPES } from './../shared/button'
import arrow from './../../images/right-arrow.png'
import 'react-datepicker/dist/react-datepicker.css'

class RecordingsFilter extends React.Component {

  constructor(props) {
    super(props)

    const { params } = props.visits
    this.state = {
      licensePlate: params.licensePlate,
      startDateMoment: params.startDateMoment,
      endDateMoment: params.endDateMoment,
      bay: params.bay,
      locationId: params.locationId
    }
  }


  locationFilter = () => {
    const locations = this.props.auth.user.locations
    locations.sort(function(a, b){
      var keyA = a.name,
          keyB = b.name;
      if(keyA < keyB) return -1;
      if(keyA > keyB) return 1;
      return 0;
    });
    if(locations.length > 1){
      return (
        <select onChange={( event ) => this.setState({locationId: event.target.value})} className='pull-down-filter' id='location-select' defaultValue={this.props.visits.params.locationId}>
          <option id='location-option' value=''> All Locations </option>
          {locations.map((location, index)=> {
            return(
              <option value={location.id} key={"location" + location.id}>{location.name}</option>
            )
           })
          }
        </select>
      )
    }
  }

  handleStartChange = (date) => {
    this.setState({startDateMoment: date})
  }

  handleEndChange = (date) => {
    this.setState({endDateMoment: date})
  }

  onFilterSubmit = (event) => {
    event.preventDefault()
    this.props.updateParams(this.state)
    this.props.fetchVisits()
  }

  render () {
    const visitParams = this.props.visits.params
    return (
      <div>
        <form className='recordings-filter' onSubmit={this.onFilterSubmit}>
          <input
            onChange={( event ) => this.setState({licensePlate: event.target.value})}
            id='license-plate'
            placeholder='License Plate'
            defaultValue={visitParams.licensePlate}/>
          <DatePicker
            selected={this.state.startDateMoment}
            selectsStart
            startDate={this.state.startDateMoment}
            endDate={this.state.endDateMoment}
            onChange={this.handleStartChange}
            placeholderText='Date From'
            showTimeSelect
            timeIntervals={15}
            dateFormat="LLL"
            timeCaption="Time"
            className='date-picker'
          />
          <img src={arrow} alt=''/>
          <DatePicker
            selected={this.state.endDateMoment}
            selectsEnd
            startDate={this.state.startDateMoment}
            endDate={this.state.endDateMoment}
            onChange={this.handleEndChange}
            placeholderText='To'
            showTimeSelect
            timeIntervals={15}
            dateFormat="LLL"
            timeCaption="Time"
            className='date-picker'
          />
          {this.locationFilter()}
          <select onChange={( event ) => this.setState({bay: event.target.value})} className='pull-down-filter' id='bay-number' defaultValue={visitParams.bay}>
            <option value=''>All Bays</option>
            <option value='1'>1</option>
            <option value='2'>2</option>
            <option value='3'>3</option>
            <option value='4'>4</option>
          </select>
          <Button
            text='Search'
            type='recordingsSearch'
            buttonType={TYPES.SUBMIT}
            id='filterSubmitButton'
          />
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    fetchVisits: (params) => {
      return dispatch(fetchVisits(params));
    },
    updateParams: (params) => {
      return dispatch(updateParams(params))
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(RecordingsFilter);



// WEBPACK FOOTER //
// ./src/components/recordings/recordingsFilter.js